export const datePart = (isoDateString: string): string => isoDateString.substring(0, 10);

export const START_OF_DAY_UTC_SUFFIX = "T00:00:00.000Z";

export const END_OF_DAY_UTC_SUFFIX = "T23:59:59.999Z";
